import { useEffect } from 'react';

import { metaApis } from '@apis/next/metaApis';
import { url } from '@utils/pages';
import { useHistory } from 'react-router-dom';

let ignoreMaintenanceRedirectWarned = false;

export const useMaintenanceRedirect = () => {
  const history = useHistory();
  const { data } = metaApis.useGet('/meta', undefined);

  useEffect(() => {
    if (data?.is_maintenance) {
      if (!localStorage.getItem('IGNORE_MAINTENANCE_REDIRECT')) {
        history.replace(url('/Maintenance'));
      } else if (!ignoreMaintenanceRedirectWarned) {
        console.warn(
          `You are in maintenance mode, but we have "localStorage.getItem('IGNORE_MAINTENANCE_REDIRECT')" === ${localStorage.getItem(
            'IGNORE_MAINTENANCE_REDIRECT',
          )}, so you are not redirected to '/Maintenance'. `,
        );
        ignoreMaintenanceRedirectWarned = true;
      }
    }
  }, [data?.is_maintenance]);
};
